<div>
  <button
    (click)="onClick($event);"
    [class]="colour"
    [disabled]="disabled"
    [id]="buttonId"
    [ngClass]="[
      fill ? 'fill' : 'outline',
      disabled ? 'disabled' : '',
      shape === 'circle' ? 'circle' : 'square',
      selected ? 'selected' : '',
      header ? 'header' : '',
      subHeader ? 'sub-header' : '',
      ]"
    type="button">
    <span [ngClass]="disabled ? 'disabled' : ''" class="center-content">
      <ng-content></ng-content>
    </span>
  </button>
</div>

